export default __webpack_public_path__ + "images/9772b256766763cd1ddf7e66a3ff95fd-coloring-book.svg";